import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://bed9d61200009e2ac4045a2e9191c2aa@o4510884643995648.ingest.us.sentry.io/4510884656513024",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});